// @ts-nocheck 11457ab7
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_quick_action_bar'], //here
      sections: [
        addPanel.sections.getSections().designPanelOnly.quickActionBarSection,
      ],
    };
  },
};
